(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primeguard-service-footer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pg-wishlist-panel')){class PGWishlistPanel extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.querySelector('.pg-open-wishlist').addEventListener('click',()=>{this.render();this.dialog.showModal();});this.querySelector('.pg-close-wishlist').addEventListener('click',()=>this.dialog.close());this.update=()=>this.render();window.addEventListener('pg-wishlist-change',this.update);window.addEventListener('storage',this.update);this.render();}
disconnectedCallback(){window.removeEventListener('pg-wishlist-change',this.update);window.removeEventListener('storage',this.update);}
list(){try{const list=JSON.parse(localStorage.getItem('primeguard-wishlist-v1')||'[]');return Array.isArray(list)?list.filter(x=>x&&typeof x.handle==='string'&&/^[a-z0-9-]+$/.test(x.handle)).slice(0,100):[];}catch{return[];}}
render(){const list=this.list(),ul=this.querySelector('ul');ul.replaceChildren();this.querySelector('[data-pg-wish-count]').textContent=list.length?'('+list.length+')':'';this.querySelector('[data-pg-wish-status]').textContent=list.length?'':this.dataset.empty;for(const item of list){const li=document.createElement('li'),a=document.createElement('a'),span=document.createElement('span'),remove=document.createElement('button');a.href=this.dataset.root+'products/'+item.handle;span.textContent=String(item.title||item.handle);try{const src=new URL(item.image);if(src.protocol==='https:'&&src.hostname==='cdn.shopify.com'){const img=document.createElement('img');img.src=src.href;img.alt='';img.width=70;img.height=70;img.loading='lazy';a.append(img);}}catch{}a.append(span);remove.type='button';remove.textContent=this.dataset.remove;remove.setAttribute('aria-label',this.dataset.remove+' '+String(item.title||item.handle));remove.addEventListener('click',()=>{try{localStorage.setItem('primeguard-wishlist-v1',JSON.stringify(this.list().filter(x=>x.handle!==item.handle)));window.dispatchEvent(new Event('pg-wishlist-change'));}catch{this.querySelector('[data-pg-wish-status]').textContent=this.dataset.blocked;}});li.append(a,remove);ul.append(li);}}
}customElements.define('pg-wishlist-panel',PGWishlistPanel);}

  } catch(e) { console.error(e); }
})();
})();
